import main from './main'

export class teras extends main{

   constructor (args) {
      super()
      this.name = 'www.biomedia.net.corsi-convegni'
      this.version = '1.0.1'
      this.urlsite = (process.env.NODE_ENV != 'development') ? document.location.origin + '/corsi-convegni/' : ''
      this.page = {
         title: 'Home',
         sezione: 'EVENTI'
      }

      this.apiUrl = 'https://api.terasmm.it/201806/'
      this.mysql = {
         composer:'db',
         adapter:'bm',
         database:'bm_bvent'
      }
   
      this.utente={}

      this.bventUrl = 'https://bvent.biomedia.net/gestionale/documenti/evento/'
      this._evento=[]
      this.evento={}
      this._nextevento = {}
      this._provider={}
      this._interesse={}
      super.init()
      return this
   }

 
}
export default new teras


// WEBPACK FOOTER //
// ./src/teras/index.js